export { RippleIcon } from './ripple-icon';
export type { RippleIconProps } from './ripple-icon';
